<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="isFilialBtnDisabled"
    :btn-prev-visible="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #btn-prev-content>
      <v-icon size="14">{{ icons.mdiMapMarker }}</v-icon>
      <span>Филиал</span>
    </template>

    <template #content>
      <div class="px-4 pb-14 pt-8">
        <p class="mb-4">
          Записаться на приём можно, указав специальность или ФИО врача:
        </p>
        <x-autocomplete
          ref="specAutocomplete"
          :value="specialityId"
          :items="specialitiesList"
          placeholder="Выберите специальность"
          item-value="id"
          item-text="name"
          :readonly="!isBtnNextDisabled"
          open-on-clear
          :menu-props="{ disableKeys: false, offsetY: true, closeOnClick: true, closeOnContentClick: true }"
          :search-input.sync="specialitySearch"
          :class="{'x-autocomplete__no-data': noSpecialityData}"
          @click="onSpecialityClick"
          @change="onSpecialityChanged"
        >
          <template #item="{ parent, item, on, attrs }">
            <v-list-item
              v-on="on"
              v-bind="attrs"
              :ripple="false"
            >
              <v-list-item-content>
                <v-list-item-title style="white-space: normal; font-size: 16px">
                  <span>{{ parent.getMaskedCharacters(item.name).start }}</span>
                  <span class="v-list-item__mask">{{ parent.getMaskedCharacters(item.name).middle }}</span>
                  <span>{{ parent.getMaskedCharacters(item.name).end }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template #no-data>
            <div class="pa-4" style="font-size: 16px; line-height: normal">
              <p class="mb-0">
                К сожалению, на данный момент отсутствуют специальности, доступные для записи.
              </p>
              <p class="mb-0">Попробуйте, пожалуйста, позже.</p>
            </div>
          </template>
        </x-autocomplete>

        <x-autocomplete
          ref="doctorAutocomplete"
          :value="doctorId"
          :items="doctorList"
          placeholder="Выберите врача"
          item-value="id"
          item-text="name"
          :readonly="!isBtnNextDisabled"
          open-on-clear
          :menu-props="{ disableKeys: false, offsetY: true, closeOnClick: true, closeOnContentClick: true }"
          :search-input.sync="doctorSearch"
          class="pt-4"
          :class="{'x-autocomplete__no-data': noDoctorData}"
          @click="onDoctorClick"
          @change="onDoctorChanged"
        >
          <template #item="{ parent, item, on, attrs }">
            <v-list-item
              v-on="on"
              v-bind="attrs"
              :ripple="false"
            >
              <v-list-item-content>
                <v-list-item-title style="white-space: normal; font-size: 16px">
                  <span>{{ parent.getMaskedCharacters(item.name).start }}</span>
                  <span class="v-list-item__mask">{{ parent.getMaskedCharacters(item.name).middle }}</span>
                  <span>{{ parent.getMaskedCharacters(item.name).end }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template #no-data>
            <div class="pa-4" style="font-size: 16px; line-height: normal">
              <p class="mb-0">
                К сожалению, на данный момент отсутствуют врачи, к которым можно было бы записаться.
              </p>
              <p class="mb-0">Попробуйте, пожалуйста, позже.</p>
            </div>
          </template>
        </x-autocomplete>
        <div
          v-if="doctorNote"
          class="d-flex flex-row"
          style="gap: 4px"
        >
          <span style="font-size: 14px; color: #999999">*</span>
          <span
            v-html="doctorNote"
            class="tiptap-data"
          />
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import {mdiMapMarker} from "@mdi/js"
import XAutocomplete from "@/components/x-env/autocomplete/XAutocomplete"
import {isEmpty, isNullOrUndefined} from "@/plugins/object-helpers"
import {WIDGET_STEP__SELECT_DOCTOR, WIDGET_STEP__SELECT_FILIAL} from "@/plugins/consts"
import WidgetStepPage from "@/components/page-template/WidgetStepPage"
import {mapGetters} from "vuex"
import {OverlayScrollbars} from "overlayscrollbars"

export default {
  components: {
    WidgetStepPage,
    XAutocomplete,
  },
  data() {
    return {
      icons: {
        mdiMapMarker,
      },

      specialitySearch: null,
      doctorSearch: null,

      noSpecialityData: false,
      noDoctorData: false,
    }
  },
  computed: {
    ...mapGetters([
      'doctorId',
      'doctorList',
      'specialityId',
      'specialitiesList',
      'filialList'
    ]),
    isBtnNextDisabled() {
      return isNullOrUndefined(this.specialityId) && isNullOrUndefined(this.doctorId)
    },
    isFilialBtnDisabled() {
      return isEmpty(this.filialList) || this.filialList.length === 1
    },
    doctorNote() {
      if (!this.doctorId) {
        return ''
      }
      const doctorItem = this.doctorList.find(it => it.id === this.doctorId)
      if (doctorItem === undefined || isNullOrUndefined(doctorItem.note)) {
        return ''
      }
      return doctorItem.note
    }
  },
  watch: {
    specialitySearch() {
      this.noSpecialityData = this.$refs.specAutocomplete.$refs.autocomplete.filteredItems.length === 0
    },
    doctorSearch() {
      this.noDoctorData = this.$refs.doctorAutocomplete.$refs.autocomplete.filteredItems.length === 0
    }
  },
  mounted() {
    this.$watch(() => {
      return this.$refs.specAutocomplete.$refs.autocomplete.isMenuActive
    }, (val) => {
      if (val) {
        requestAnimationFrame(() => {
          for (let node of document.getElementsByClassName("v-autocomplete__content")) {
            OverlayScrollbars(node, {})
          }
        })
      }
    })

    this.$watch(() => {
      return this.$refs.doctorAutocomplete.$refs.autocomplete.isMenuActive
    }, (val) => {
      if (val) {
        requestAnimationFrame(() => {
          for (let node of document.getElementsByClassName("v-autocomplete__content")) {
            OverlayScrollbars(node, {})
          }
        })
      }
    })
  },
  methods: {
    isNullOrUndefined,

    onDoctorClick(event) {
      if (this.$refs.doctorAutocomplete.$refs.autocomplete.isMenuActive) {
        this.$refs.doctorAutocomplete.$refs.autocomplete.isMenuActive = false
        event.stopImmediatePropagation()
      }
    },

    onDoctorChanged(val) {
      this.$store.commit('setDoctorId', val)
      this.$store.commit('setSpecialityId', null)
    },

    onSpecialityClick(event) {
      if (this.$refs.specAutocomplete.$refs.autocomplete.isMenuActive) {
        this.$refs.specAutocomplete.$refs.autocomplete.isMenuActive = false
        event.stopImmediatePropagation()
      }
    },

    onSpecialityChanged(val) {
      this.$store.commit('setSpecialityId', val)
      this.$store.commit('setDoctorId', null)
    },

    onBtnPrevClicked() {
      this.$emit('change-filial')
    },

    async onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }

      if (!isNullOrUndefined(this.specialityId)) {
        await this.getScheduleBySpec()
        this.$emit('change-step', WIDGET_STEP__SELECT_DOCTOR)
        return
      }

      if (!isNullOrUndefined(this.doctorId)) {
        await this.getScheduleByDoctor()
        this.$emit('change-step', WIDGET_STEP__SELECT_FILIAL)
      }
    },

    /**
     * Получение списка врачей с предварительным расписанием по специальности (для шага 2.1)
     */
    async getScheduleBySpec() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .get(`${this.$backendLink}/widget/schedule-speciality`, {
          params: {
            specialityId: this.specialityId,
          }
        })
        .then(response => {
          this.$store.commit('setFilialDoctorsLists', response.data.doctors)
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    },

    /**
     * Получение списка специальностей с предварительным расписанием по врачу (для шага 2.2)
     */
    async getScheduleByDoctor() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .get(`${this.$backendLink}/widget/schedule-doctor-filials`, {
          params: {
            doctorId: this.doctorId,
          }
        })
        .then(response => {
          this.$store.commit('setDoctorFilialsLists', response.data)
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    }
  }
}
</script>

<style scoped>

</style>